/**
 * 发文记录 API — GET /api/publish-records + PATCH /api/publish-records/{id}。
 *
 * 二期批2（PRD §4.6.4）：
 * - 列表新增 product_id / unattributed / company_id 过滤参数；
 * - 新增补标写操作 patchPublishRecord（Web 端唯一发文写入口）。
 */
import client from "./client";
import type { PublishRecord } from "../types";

/** 发文记录查询参数。 */
export interface PublishRecordParams {
  brand_id?: string;
  /** 选择器产品过滤（二期批2 新增，后端已支持）。 */
  product_id?: string;
  /** 选择器公司过滤（经 brand → company 展开）。 */
  company_id?: string;
  /** 传 "1" 时仅返回未归因记录（product_id IS NULL）。 */
  unattributed?: string;
  start_date?: string;
  end_date?: string;
}

/** 获取发文记录列表。 */
export async function getPublishRecords(
  params?: PublishRecordParams,
): Promise<PublishRecord[]> {
  return client.get<unknown, PublishRecord[]>("/publish-records", { params });
}

/**
 * 发文补标产品（PRD §4.6.4 UI 补标入口）。
 * PATCH /api/publish-records/{id}，body { product_id }。
 * 后端校验产品存在且属于该发文的同账户同品牌，写入 product_id 并刷新快照。
 */
export async function patchPublishRecord(
  recordId: string,
  productId: string,
): Promise<PublishRecord> {
  return client.patch<unknown, PublishRecord>(`/publish-records/${recordId}`, {
    product_id: productId,
  });
}
